import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { version } from '../../package.json';
import {environment} from '../environments/environment';

@Component({
  selector: 'elastic-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private translocoService: TranslocoService,
    private titelService: Title
    ) {
  }

  ngOnInit() {
    let preferedLanguage = localStorage.getItem('nuvolaLanguage');
    if (!preferedLanguage) {
      preferedLanguage = this.translocoService.getActiveLang();
      localStorage.setItem('nuvolaLanguage', preferedLanguage);
    }
    this.translocoService.setActiveLang(preferedLanguage);

    const currentTilte = this.titelService.getTitle();
    this.titelService.setTitle(`${currentTilte} - v. ${version}`);

    const script = document.getElementById('google_map_script');
    if (script) {
      script.setAttribute('src',
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&language=${preferedLanguage}`
      );
    }
  }
}
